import { render, staticRenderFns } from "./productcategory.vue?vue&type=template&id=3fb3c1b0&"
import script from "./productcategory.vue?vue&type=script&lang=js&"
export * from "./productcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports